import Turbolinks from "turbolinks";

import { extractCSRFToken } from "./util/csrf";

// 同一セッションで登録を繰り返さないための目印。
// cookieが保存されない環境（cookieブロック等）でリロードが繰り返されるのを防ぐ。
const ATTEMPTED_KEY = 'detectedTimeZone';

// ブラウザが認識しているIANAタイムゾーン。取れなければ空文字
export const detectTimeZone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
  } catch {
    return '';
  }
};

const findMeta = (name: string): HTMLMetaElement | null => {
  const element = document.getElementsByName(name).item(0);
  return element instanceof HTMLMetaElement ? element : null;
};

// ブラウザ検出のタイムゾーンをサーバに登録し、描画に使われたゾーンと違えばページを描き直す。
// 年齢確認モーダルが出ているページでは何もしない。モーダルの「表示する」フォームに同梱して送り、
// 再描画もそちらに任せる（age_check.ts）。こうしないと、登録完了とモーダル表示が競合してモーダルが二重に出る
export const setTimeZone = () => {
  const registered = findMeta('detected-time-zone');
  const rendered = findMeta('rendered-time-zone');
  if (registered == null || rendered == null) {
    return;
  }

  if (document.getElementById('ageCheckModal') != null) {
    return;
  }

  const detected = detectTimeZone();
  // サーバが既に同じゾーンを把握しているなら通信しない。通常のページ遷移はここで終わる
  if (!detected || detected === registered.content) {
    return;
  }

  try {
    if (sessionStorage.getItem(ATTEMPTED_KEY) === detected) {
      return;
    }
    sessionStorage.setItem(ATTEMPTED_KEY, detected);
  } catch {
    // sessionStorageが使えない環境では登録自体を諦める（リロードループを避けるため）
    return;
  }

  fetch('/api/time_zone', {
    method: 'PATCH',
    body: JSON.stringify({ time_zone: detected }),
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': extractCSRFToken(),
    },
  }).then((response) => {
    if (!response.ok) {
      return null;
    }
    return response.json() as Promise<{ effective_time_zone?: string }>;
  }).then((body) => {
    if (body == null) {
      return;
    }

    registered.content = detected;

    // 描画に使われたゾーンが変わらないなら（JSTのユーザーや、設定で明示選択済みのユーザー）描き直さない
    const effective = body.effective_time_zone ?? detected;
    if (effective === rendered.content) {
      return;
    }

    Turbolinks.visit(window.location.href, { action: 'replace' });
  }).catch(() => {
    // 登録に失敗しても表示はアプリ既定のゾーンのままで続行できる
  });
};

export default setTimeZone;
